import { render, staticRenderFns } from "./oldHome.vue?vue&type=template&id=29a99847&scoped=true&"
import script from "./oldHome.vue?vue&type=script&lang=js&"
export * from "./oldHome.vue?vue&type=script&lang=js&"
import style0 from "./oldHome.vue?vue&type=style&index=0&id=29a99847&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a99847",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29a99847')) {
      api.createRecord('29a99847', component.options)
    } else {
      api.reload('29a99847', component.options)
    }
    module.hot.accept("./oldHome.vue?vue&type=template&id=29a99847&scoped=true&", function () {
      api.rerender('29a99847', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/oldHome.vue"
export default component.exports